import { render, staticRenderFns } from "./TagFormModal.vue?vue&type=template&id=0344b091&"
import script from "./TagFormModal.vue?vue&type=script&lang=js&"
export * from "./TagFormModal.vue?vue&type=script&lang=js&"
import style0 from "./TagFormModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports